import { Component } from '@angular/core';


export class SkyModalContentComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-modal-content',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
